import { c as _c } from "react/compiler-runtime";
import { ContactFieldValueInterface } from '@systemeio/types';
import { useControlledSwr } from '@systemeio/util';
import { ContactId } from 'modules/contacts/types/contact-interface';
import { useCallback, useState } from 'react';
import { RequestModuleEnum } from 'shared/enums/request-module-enum';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import { CONTACT_API } from '../api/contact-api';
export interface ContactTooltipDataInterface {
  id: number;
  fieldValues: ContactFieldValueInterface[];
  referredBy: {
    id: number;
    removedAt: number | null;
    fieldValues: ContactFieldValueInterface[];
    referredBy: null;
  } | null;
}
export const useContactsTooltipData = () => {
  const $ = _c(14);
  const {
    user
  } = useUser();
  const [contactId, setContactId] = useState(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher
  } = useFetch(t0);
  const t1 = `${CONTACT_API}/contacts/${contactId}/tooltip-data`;
  let t2;
  if ($[1] !== t1) {
    t2 = [t1, RequestModuleEnum.Contacts];
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    data: contactData,
    abort
  } = useControlledSwr(t2, fetcher, undefined, !!contactId && !!user);
  let t3;
  if ($[3] !== abort || $[4] !== contactId) {
    t3 = id => {
      if (id === contactId) {
        return;
      }
      abort();
      setContactId(id);
    };
    $[3] = abort;
    $[4] = contactId;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const fetchContactData = t3;
  let t4;
  if ($[6] !== abort || $[7] !== contactData) {
    t4 = () => {
      abort();
      if (contactData) {
        return;
      }
      setContactId(null);
    };
    $[6] = abort;
    $[7] = contactData;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const clearContactData = t4;
  let t5;
  if ($[9] !== abort || $[10] !== clearContactData || $[11] !== contactData || $[12] !== fetchContactData) {
    t5 = {
      contactData,
      fetchContactData,
      abort,
      clearContactData
    };
    $[9] = abort;
    $[10] = clearContactData;
    $[11] = contactData;
    $[12] = fetchContactData;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};